var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { IdOutskirtBuildings } from "../../constants/IdOutskirtBuildings";
import { OutskirtBuildingWithLevel, } from "../outskirts/OutskirtBuildingWithLevel";
var OutskirtBuildingNursery = /** @class */ (function (_super) {
    __extends(OutskirtBuildingNursery, _super);
    function OutskirtBuildingNursery() {
        return _super.call(this, IdOutskirtBuildings.Nursery) || this;
    }
    return OutskirtBuildingNursery;
}(OutskirtBuildingWithLevel));
export { OutskirtBuildingNursery };



//////////////////
// WEBPACK FOOTER
// ./src/features/nursery/OutskirtBuildingNursery.ts
// module id = 2177
// module chunks = 3